import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Injector, NgModule, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Observable, of, map, combineLatest } from 'rxjs';
import { AccountEntity, ContactType, ContactUtility, UnallocatedUser } from '@jms/model';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { PickerItemModule } from '@jms/ui/ui.picker.item';
import { HttpClient } from '@angular/common/http';
import { EntityItemModule } from '../entity.item';
import { ObservableInput } from '@jms/utils/util.redux';

@Component({
    selector: 'appointment-resource-picker',
    templateUrl: './appointment.resource.picker.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AppointmentResourcePickerComponent, multi: true }
    ],
    standalone: false
})
export class AppointmentResourcePickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: AccountEntity[];
  @Input() public placeholder = '<Resource>';
  @Input() public appendTo: string;
  @Input() public displayLimit: number = -1;
  @Input() public types: ContactType[] = [ContactType.Employee, ContactType.Subcontractor];
  @ObservableInput(false) @Input('showUnallocatedUser') public showUnallocatedUser$: Observable<boolean>;


  public data$: Observable<AccountEntity[]>;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges(changes: SimpleChanges) {

    super.ngOnChanges(changes);

    const data$ = this.fetch === PickerFetch.Automatic
      ? this.getResources(this.types)
      : of(this.data);

    this.data$ = combineLatest([
      data$,
      this.showUnallocatedUser$
    ])
      .pipe(
        map(([items, unallocated]) => {

          let resources = ContactUtility.contactGrouping(items) as any[];

          if (unallocated) {
            resources = [UnallocatedUser as any, ...resources];
          }

          return resources;

        })
      );

  }


  private getResources(types: ContactType[]): Observable<AccountEntity[]> {
    return this.http.post<AccountEntity[]>(`/api/picker/contact/appointment`, { types });
  }



}


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule,
    EntityItemModule
  ],
  declarations: [
    AppointmentResourcePickerComponent
  ],
  providers: [],
  exports: [
    AppointmentResourcePickerComponent
  ],
})
export class AppointmentResourcePickerModule { }